// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"e7fd3b7c","439":"abdaeb4a","466":"399ecca7"}[chunkId] + ".chunk.css";
};